import React from "react";
import { MapMarker, Map } from "react-kakao-maps-sdk";

const MainMap = () => {
  return (
    <div className="map_wrap">
      <div className="map_area">
        <Map
          className="kakao_map"
          center={{ lat: 37.50443, lng: 127.000792 }} // 지도의 중심 좌표
          level={3} // 지도 확대 레벨
        >
          <MapMarker
            className="kakao_marker"
            position={{ lat: 37.50443, lng: 127.000792 }}
          ></MapMarker>
        </Map>
      </div>
    </div>
  );
};

export default MainMap;
